import React from 'react';
import { SearchIcon, UsersIcon, ClipboardCheckIcon, ZapIcon } from 'lucide-react';
import { services } from '../../lib/data';
import { Eyebrow, Reveal } from '../ui/Reveal';
const icons = [SearchIcon, UsersIcon, ClipboardCheckIcon, ZapIcon];
export function Services() {
  return <section id="services" className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-id="element-116" data-mp="21zhdwpw1dy02">
      <div className="max-w-2xl" data-id="element-117" data-mp="2zmzuunzuq6f5">
        <Eyebrow data-id="element-118" data-mp="2zly83m9h3vhl">What we do</Eyebrow>
        <h2 className="mt-6 font-serif text-3xl leading-tight text-ink sm:text-4xl" data-id="element-119" data-mp="2zm6ovp8pvky2">
          A complete practice for leadership.
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-ink-600" data-id="element-120" data-mp="2pwn0y565d0wc">
          From the boardroom to interim cover, we bring rigour and discretion to every
          mandate that matters.
        </p>
      </div>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-121" data-mp="3idr13gojlgpb">
        {services.map((service, i) => {
        const Icon = icons[i];
        return <Reveal key={service.title} delay={i * 0.1} data-id="element-122" data-mp="8hu6p80amjl1" data-mpi={i}>
              <div className="group flex h-full flex-col rounded-2xl border border-ink/10 bg-ivory-50 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-gold/50 hover:shadow-lift" data-id="element-123" data-mp="8idpeqxrpc04">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-ink text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-ink" data-id="element-124" data-mp="3uwn8qlmubtu1">
                  <Icon className="h-5 w-5" data-id="element-125" data-mp="3kyzd7theuiat" />
                </span>
                <h3 className="mt-6 font-serif text-xl text-ink" data-id="element-126" data-mp="3pyc2ekvr81gk">{service.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-ink-600" data-id="element-127" data-mp="3pvzbhi80qgrd">
                  {service.description}
                </p>
                <ul className="mt-5 space-y-2 border-t border-ink/10 pt-5" data-id="element-128" data-mp="3gwvsee8uq1cv">
                  {service.points.map(p => <li key={p} className="flex items-center gap-2 text-xs text-ink-600" data-id="element-129" data-mp="1a7qx4zlw0feq">
                      <span className="h-1 w-1 rounded-full bg-gold" data-id="element-130" data-mp="1f4zi17yf6xjo" />
                      {p}
                    </li>)}
                </ul>
              </div>
            </Reveal>;
      })}
      </div>
    </section>;
}